-<template>
    <div class="blackBg animate__animated animate__slideInLeft">
        <div class="cardTit">
            <span class="teamName">精彩瞬间</span>
        </div>
        <div class="cardBg">
            <carousel :interval="3000" height="38vw" :arrow="'never'" :indicator-position="'none'">
                <carousel-item v-for="i in imgList.length">
                    <img style="width: 75%" :src="imgList[i-1]" alt="">
                </carousel-item>
            </carousel>
        </div>
    </div>

</template>

<script>
    export default {
        name: "moment",
        data(){
            return {
                imgList: [
                    require('@/assets/img/moment/1.png'),
                    require('@/assets/img/moment/2.png'),
                ]
            }
        },
        mounted() {
            this.$parent.$parent.imgAi(this.$imgJson.taskAiImgArr);
            this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl('这是俱乐部精彩瞬间'), true, true, 1);
        }
    }
</script>

<style scoped lang="less">
    .cardTit {
        background-image: url("../assets/img/updateImg/head_2.png");
        position: relative;
        font-size: 30px;
        margin-top: 1vw;
    }

    .cardBg {
        padding: 2vw;
        box-sizing: border-box;
        height: calc(100% - 140px);
        min-height: calc(100% - 140px);
        text-align: center;
    }
</style>
